export default __webpack_public_path__ + "static/this-e045ed724d8fada921c782b98ba2fec0.png";